import "./RotateSection.css";

export default function RotateSection({ children }) {
	return <div className="rotateIn">{children}</div>;
}
